import React from "react";
import { twMerge } from "tailwind-merge";

const Switch = ({ className, checked, onCheckedChange, ...props }) => {
  return (
    <label className="flex items-center cursor-pointer">
      <input
        type="checkbox"
        className="sr-only peer"
        checked={checked}
        onChange={(e) => onCheckedChange && onCheckedChange(e.target.checked)}
        {...props}
      />
      <div
        className={twMerge(
          "relative w-11 h-6 bg-gray-200 rounded-full peer-focus:ring-2 peer-focus:ring-blue-500 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border after:border-gray-300 after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600",
          className
        )}
      ></div>
      {props.children && (
        <span className="ml-3 text-sm font-medium text-gray-900">
          {props.children}
        </span>
      )}
    </label>
  );
};

export default Switch;
